// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__GPTNG","active":"Pagination_active__S-Btt","previous":"Pagination_previous__2lHo1","next":"Pagination_next__kb8bl"};